module.exports = __webpack_public_path__ + "img/119.0dc488ae.jpg";